import { UserManager, WebStorageStateStore } from 'oidc-client-ts';
import { jwtDecode } from 'jwt-decode';
import { getRuntimeEnv } from '../config/runtimeConfig';

class AuthService {
  constructor() {
    this.userManager = null;
    this.user = null;
    this.initialized = false;
  }

  async init() {
    if (this.initialized) return;

    const authUrl = getRuntimeEnv('REACT_APP_AUTH_URL', '');
    const authRealm = getRuntimeEnv('REACT_APP_AUTH_REALM', '');
    const clientId = getRuntimeEnv('REACT_APP_AUTH_CLIENT_ID', 'digitaltwin-explorer');

    const authority = authRealm 
      ? `${authUrl}/realms/${authRealm}`
      : authUrl;

    this.userManager = new UserManager({
      authority,
      client_id: clientId,
      redirect_uri: window.location.origin,
      post_logout_redirect_uri: window.location.origin,
      response_type: 'code',
      scope: 'openid profile email',
      userStore: new WebStorageStateStore({ store: window.localStorage }),
      automaticSilentRenew: true
    });

    this.userManager.events.addUserLoaded((user) => {
      this.user = user;
    });

    this.userManager.events.addAccessTokenExpired(() => {
      this.logout();
    });

    try {
      if (window.location.search.includes('code=') && window.location.search.includes('state=')) {
        this.user = await this.userManager.signinCallback();
        window.history.replaceState({}, document.title, window.location.pathname);
      } else {
        this.user = await this.userManager.getUser();
      }

      if (this.user && !this.user.expired) {
        this.initialized = true;
        console.log("OIDC authenticated successfully");
      } else {
        await this.userManager.signinRedirect();
      }
    } catch (error) {
      console.error("OIDC initialization failed", error);
      if (this.userManager) {
        await this.userManager.signinRedirect();
      }
    }
  }

  getToken() {
    return this.user?.access_token;
  }

  getTokenParsed() {
    if (!this.user?.access_token) return null;
    try {
      return jwtDecode(this.user.access_token);
    } catch (e) {
      return null;
    }
  }

  getUser() {
    if (!this.user) return null;
    let roles = [];
    try {
      const decoded = jwtDecode(this.user.access_token);
      roles = decoded.realm_access?.roles || [];
    } catch (e) {}

    return {
      name: this.user.profile.name || this.user.profile.preferred_username,
      username: this.user.profile.preferred_username,
      roles: roles,
      accessToken: this.user.access_token
    };
  }

  logout() {
    if (this.userManager) {
      this.userManager.signoutRedirect();
    }
  }
}

export const authService = new AuthService();
